module.exports = {"(^|\\.)espnfc\\.":"/football","(^|\\.)espncricinfo\\.":"/cricket"}


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/hostPaths.json
// module id = 830
// module chunks = 0